import Dashboard from './Dashboard.vue';

export const dashboardRoutes = [
  { path: '', component: Dashboard, name: 'dashboard' },
];
